/**------------------------------------------------------
 * Temperature Definitions
 */
export enum EnumTemperature {
	Celsius 		= 'temperature_c',
	Fahrenheit 		= 'temperature_f'
}
